import Img2 from "../images/testimonials/user.jpg";
import Img3 from "../images/testimonials/user2.jpg";

function Testimonials() {
  return (
    <>
      <section className="testimonials-section" style={{marginTop:'-8%'}}>
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4 style={{ fontFamily: 'Montserrat'}}>Reviewed by People</h4>
              <h2 style={{ fontFamily: 'Montserrat'}}>Client's Testimonials</h2>
              <p style={{ fontFamily: 'Montserrat'}}>
                Discover the positive impact we've made on the our clients by
                reading through their testimonials. Our clients have experienced
                our service and results, and they're eager to share their
                positive experiences with you.
              </p>
            </div>

            <div className="all-testimonials">
              <div className="all-testimonials__box">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right" style={{color:'#f7931e'}}></i>
                </span>
                <p style={{ fontFamily: 'Montserrat'}}>
                  "We book a car from this website and had an amazing
                  experience! The booking was easy and the rates were
                  very affordable. "
                </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img2} alt="user_img" />
                    <span>
                      <h4 style={{ fontFamily: 'Montserrat'}}>Cletus Ajibade</h4>
                      <p style={{ fontFamily: 'Montserrat'}}>Medical Doctor</p>
                    </span>
                  </div>
                </div>
              </div>

              <div className="all-testimonials__box box-2">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right" style={{color:'#f7931e'}}></i>
                </span>
                <p style={{ fontFamily: 'Montserrat'}}>
                  "The car was in great condition and made our trip even better.
                  Highly recommend for this car booking website!"
                </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img3} alt="user_img" />
                    <span>
                      <h4 style={{ fontFamily: 'Montserrat'}}>Falana Elizabeth</h4>
                      <p style={{ fontFamily: 'Montserrat'}}>Lecturer</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
